var _g, _path, _circle, _g2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLevel = function SvgLevel(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1777_16825)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21.5,
    r: 17.5,
    fill: "#B384FD"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1777_16825)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.7221 33.726C40.7505 26.6976 40.7505 15.3024 33.7221 8.274C26.6938 1.24562 15.2985 1.24562 8.27013 8.274C1.24175 15.3024 1.24175 26.6976 8.27013 33.726C15.2985 40.7544 26.6938 40.7544 33.7221 33.726Z",
    fill: "#B180FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1777_16825",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 36,
    height: 36
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 18,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1777_16825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.9959 24.504L33.4486 18.9567L28.7071 18.42L25.4165 15.1294L20.5797 13.8757L18.0777 16.6194L21.7429 20.2846L20.2696 22.352L16.8742 18.9567L12.4778 17.4117L10.0457 20.4467L12.1745 22.5754L11.6596 23.5202L15.4769 27.3376L15.2166 28.9278L12.2402 25.9515L11.2369 30.6645L17.8646 37.2923L17.2676 37.718L22.4498 42.9002C31.7137 42.1627 39.0015 34.4113 39.0015 24.9577C39.0015 24.806 38.9996 24.6547 38.9959 24.504Z",
    fill: "#9A4DFF"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2415 30.6645V25.9514H12.2448V29.7812H14.2375V30.6645H11.2415Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9368 30.6645V25.9514H18.272V26.8347H15.9403V27.8309H18.2225V28.7142H15.9403V29.7811H18.272V30.6644H14.9368V30.6645Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0063 29.5763L19.699 25.9514H18.5543L20.3774 30.6645H21.0802V29.3702L21.0063 29.5763Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0027 30.6645L21.0063 29.5763L22.3064 25.9514H23.4511L21.6351 30.6645H21.0027Z",
    fill: "#E9EDF5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8889 30.6645V25.9514H27.2241V26.8347H24.8923V27.8309H27.1746V28.7142H24.8923V29.7811H27.2241V30.6644H23.8889V30.6645Z",
    fill: "#E9EDF5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0082 30.6645V25.9514H29.0116V29.7812H31.0042V30.6645H28.0082Z",
    fill: "#E9EDF5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0013 10.7144L16.5862 15.1278L18.0775 16.6196L19.9465 14.7513V23.5205H21.0753V10.7884L21.0013 10.7144Z",
    fill: "#FFCE00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4164 15.1296L21.0013 10.7144L20.9979 23.5205H22.0559V14.7522L23.9247 16.6211L25.4164 15.1296Z",
    fill: "#FDBA12"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4484 18.9568L29.2886 14.7966L25.1287 18.9551L26.6199 20.4469L28.2337 18.8337V23.5204H30.3431V18.8345L31.9567 20.4483L33.4484 18.9568Z",
    fill: "#FDBA12"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.55426 18.9551L10.0455 20.4469L11.6593 18.8337V23.5204H13.7687V18.8345L15.3823 20.4483L16.874 18.9568L12.7142 14.7966L8.55426 18.9551Z",
    fill: "#FFCE00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1777_16825",
    x: 1,
    y: 1,
    width: 41,
    height: 41,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "effect1_foregroundBlur_1777_16825"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1777_16825"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(3 3)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLevel);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/level.ad336fea830f2db7e8c0bd8ff800a7d8.svg";